// 出差申请单
import { getDictone } from '@api/manageApi'
const state = {
  searchParams: {},
  SALE_ORDER_STATUS: {},
  detail: {}
}
const getters = {}
const actions = {
  async setSALE_ORDER_STATUS ({ commit, state }) {
    if (
      JSON.stringify(state.SALE_ORDER_STATUS) === '{}' ||
      !state.SALE_ORDER_STATUS
    ) {
      // 获取行程单订单状态
      const { data: res } = await getDictone({ code: 'SALE_ORDER_STATUS' })
      commit('setSALE_ORDER_STATUS', res.data.SALE_ORDER_STATUS)
    }
  }
}
const mutations = {
  setApplyOrderSearchParams (applyOrderStore, data) {
    applyOrderStore.searchParams = data || {}
  },
  setSALE_ORDER_STATUS (applyOrderStore, data) {
    applyOrderStore.SALE_ORDER_STATUS = data || {}
  },
  set_detail (applyOrderStore, data) {
    applyOrderStore.detail = data || {}
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/applyOrderStore.js